import { Injectable } from '@angular/core';
import { LocalStorageUtils } from './localstorage';

@Injectable({
  providedIn: 'root',
})
export class SetDefaultLanguageService {
  public LocalStorage = new LocalStorageUtils();

  constructor() {}

  setDefaultLanguage(): string {
    const language = this.LocalStorage.getCurrentLanguage();
    if (language !== 'pt-BR') {
      return 'es-PE';
    }
    return 'br';
  }
}
